import React from "react";
import PropTypes from "prop-types";
import { CallbackComponent } from "redux-oidc";

import { UIFullScreenLoader } from "components/UI/Loader";

const Callback = ({ userManager, onSuccess, onError }) => (
  <CallbackComponent
    userManager={userManager}
    successCallback={onSuccess}
    errorCallback={onError}
  >
    <UIFullScreenLoader />
  </CallbackComponent>
);

Callback.propTypes = {
  userManager: PropTypes.object.isRequired,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
};

Callback.defaultProps = {
  onSuccess: () => {},
  onError: () => {}
};

export default Callback;
